var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M8 6.082v11.84c0 .96 1.214 1.44 1.926.76l5.422-5.18c.87-.83.87-2.18 0-3.01l-2.062-1.97-3.36-3.21C9.214 4.642 8 5.122 8 6.082Z","fill":"var(--v-grey-darken-1)"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }